import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { OptInComponent } from './opt-in.component';

const declarations = [OptInComponent];
const exports = [...declarations];

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  declarations,
  exports,
})
export class OptInComponentModule {}
